import { render, staticRenderFns } from "./ReportUser.vue?vue&type=template&id=271dd918&"
import script from "./ReportUser.vue?vue&type=script&lang=js&"
export * from "./ReportUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports